import styled, { keyframes } from 'styled-components';

const menuIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const AvatarNavWidgetStyled = styled.div`
  position: relative;
  .avatar_nav_container {
    display: flex;
    align-items: center;
    column-gap: 0.75rem;
    padding: 6px 8px 6px 14px;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
    .nui_left_col {
      .il_title {
        text-align: right;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
        transition: color 0.2s ease;
      }
      .il_sub_title {
        color: ${({ theme }) => theme.COLORS.GRAY_5};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      }
    }
    .nui_right_col {
      border-radius: 50%;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    &:hover,
    &.active {
      background-color: ${({ theme }) => theme.COLORS.WHITE_1};
      box-shadow: 0 2px 12px rgb(8 21 66 / 8%);
      .il_title {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
      .nui_right_col {
        transform: scale(1.06);
        box-shadow: 0 0 0 3px ${({ theme }) => theme.COLORS.PURPLE_3};
      }
    }
  }
  .avatar_nav_menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 100;
    border-width: 0;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgb(8 21 66 / 12%);
    padding: 0.5rem;
    min-width: 10rem;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    transform-origin: top right;
    animation: ${menuIn} 0.16s ease-out;
    .atn_menu_item {
      padding: 0.5rem 0.75rem;
      border-radius: 8px;
      display: flex;
      align-items: center;
      column-gap: 0.5rem;
      cursor: pointer;
      transition: background-color 0.15s ease;
      span {
        color: ${({ theme }) => theme.COLORS.BLUE_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      }
      &:hover {
        background-color: ${({ theme }) => theme.COLORS.GRAY_13};
        span {
          color: ${({ theme }) => theme.COLORS.RED_1};
        }
      }
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .avatar_nav_container,
    .nui_right_col,
    .atn_menu_item {
      transition: none;
    }
    .avatar_nav_menu {
      animation: none;
    }
  }
`;
